export class RespuestaLogin {
    accessToken?: string;
    expiresIn: number;
    refreshToken?: string;
    idToken?: string;
    tokenPermisos?: string;
    returnUrl?: string;
    session?: string;
    usaCookie: boolean;
}
